module.exports = "/assets/about/hero_about.png?wDOIttK";